export default __webpack_public_path__ + "static/media/InviteSentTick.e8e52a05.svg";